module.exports = __webpack_public_path__ + "img/galois.bec24a11.png";